import {
  VStack, Text, Box, Flex,
} from '@chakra-ui/react';
import React from 'react';

interface AvatarListItemProps {
  avatar: React.ReactNode;
  name: string;
  subtitles?: string[];
  size?: 'xs' | 'sm' | 'md';
  rightElement?: React.ReactNode;
  boldName?: boolean;
  nameFontWeight?: string;
  showSubtitle?: boolean;
  onClick?: () => void;
}

const AvatarListItem: React.FC<AvatarListItemProps> = ({
  avatar,
  name,
  subtitles,
  size = 'md',
  rightElement,
  boldName = false,
  nameFontWeight = 'normal',
  showSubtitle = true,
  onClick,
}) => (
  <Box w="100%" className="user-row-box">
    <Flex gap={3} alignItems="center">
      {avatar}
      <VStack gap={0} alignItems="flex-start">
        <Text
          lineClamp={1}
          maxWidth={250}
          m={0}
          title={name}
          fontSize={(showSubtitle && '0.875rem') || (boldName ? 'md' : size)}
          fontWeight={nameFontWeight || (size === 'md' || boldName ? 'semibold' : 'normal')}
          onClick={onClick}
          _hover={onClick ? {
            textDecoration: 'underline',
            cursor: 'pointer',
          } : {}}
        >
          {name}
        </Text>
        {showSubtitle && subtitles && subtitles.length > 0 && (
          subtitles.map((subtitle) => (
            <Text
              fontSize="0.75rem"
              lineClamp={1}
              maxWidth={250}
              title={subtitle}
              mt={1}
              color="gray.500"
              mb={0}
            >
              {subtitle}
            </Text>
          ))
        )}
      </VStack>
      {rightElement && (
        <Box ml="auto">
          {rightElement}
        </Box>
      )}
    </Flex>
  </Box>
);

export default AvatarListItem;
